import { ElementNode } from 'lexical';

export class CollapsibleContainerNode extends ElementNode {
  __open;

  static getType() {
    return 'collapsible-container';
  }

  static clone(node) {
    return new CollapsibleContainerNode(node.__open, node.__key);
  }

  constructor(open, key) {
    super(key);
    this.__open = open;
  }

  createDOM(config) {
    const dom = document.createElement('details');
    dom.classList.add('Collapsible__container');
    dom.open = this.__open;
    dom.addEventListener('toggle', () => {
      const open = dom.open;
      if (this.__open !== open) {
        const editor = config._parentEditor || config.editor;
        if (editor) {
          editor.update(() => {
            const writable = this.getWritable();
            writable.__open = open;
          });
        }
      }
    });
    return dom;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__open !== this.__open) {
      dom.open = this.__open;
    }
    return false;
  }

  static importDOM() {
    return {
      details: () => ({
        conversion: convertDetailsElement,
        priority: 1,
      }),
    };
  }

  static importJSON(serializedNode) {
    const node = $createCollapsibleContainerNode(serializedNode.open);
    return node;
  }

  exportDOM() {
    const element = document.createElement('details');
    element.classList.add('Collapsible__container');
    if (this.__open) {
      element.setAttribute('open', '');
    }
    return { element };
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      open: this.__open,
      type: 'collapsible-container',
      version: 1,
    };
  }

  setOpen(open) {
    const writable = this.getWritable();
    writable.__open = open;
  }

  getOpen() {
    return this.getLatest().__open;
  }

  toggleOpen() {
    this.setOpen(!this.getOpen());
  }
}

function convertDetailsElement(domNode) {
  const isOpen = domNode.open !== undefined ? domNode.open : true;
  const node = $createCollapsibleContainerNode(isOpen);
  return { node };
}

export function $createCollapsibleContainerNode(isOpen) {
  return new CollapsibleContainerNode(isOpen);
}

export function $isCollapsibleContainerNode(node) {
  return node instanceof CollapsibleContainerNode;
}
